import { render, staticRenderFns } from "./TravelServiceBookedView.vue?vue&type=template&id=4c11a4d6&scoped=true&"
import script from "./TravelServiceBookedView.vue?vue&type=script&lang=js&"
export * from "./TravelServiceBookedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c11a4d6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VCol,VIcon,VRow,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c11a4d6')) {
      api.createRecord('4c11a4d6', component.options)
    } else {
      api.reload('4c11a4d6', component.options)
    }
    module.hot.accept("./TravelServiceBookedView.vue?vue&type=template&id=4c11a4d6&scoped=true&", function () {
      api.rerender('4c11a4d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/travel-service/TravelServiceBookedView.vue"
export default component.exports